import { Box, Stack, Typography } from '@mui/material';

import AddFiles from '@assets/add-files.svg';

const NoFiles = () => (
  <Stack alignItems="center" spacing={1} sx={{ px: 3, py: 7 }}>
    <Box
      component="img"
      src={AddFiles}
      alt="No files"
      sx={{
        width: 128,
        height: 128,
        userSelect: 'none',
        pointerEvents: 'none',
      }}
    />
    <Typography variant="h3" align="center">
      No files in this location
    </Typography>
    <Typography variant="body2" align="center" color="text.secondary">
      Upload a file or create a directory to begin organizing clinical data.
    </Typography>
  </Stack>
);

export default NoFiles;
